import React from 'react';
import cn from 'classnames';

import { IMG_TINT_ATTR, UNIFORM_PROPS } from 'common/constants';
import { prependUrlProtocol } from 'common/utils/helpers';
import { BBCommonProps } from 'types/story';
import withCardTransitionContext from 'client/components/common/BuildingBlocks/BuildingBlockEnhancer';

import css from './Img.scss';

type Props = BBCommonProps;

class Img extends React.Component<Props> {
	renderEditable() {
		const props = { ...this.props.editableModeProps?.nodeProps };
		return this.renderDefault(props);
	}

	renderDefault(props: any = {}) {
		const { stateAttrs, eventListeners } = this.props;
		const { nodeProps } = this.props.uiConfig;
		const className = cn(css.img, nodeProps.className, props.className);
		const { Component, ...componentProps } = getComponent(this.props);

		return (
			<Component
				{...componentProps}
				{...nodeProps}
				{...stateAttrs}
				{...eventListeners}
				{...props}
				className={className}
			>
				<span {...{ [IMG_TINT_ATTR]: '' }} />
			</Component>
		);
	}

	render() {
		return this.props.isEditableMode ? this.renderEditable() : this.renderDefault();
	}
}

function getComponent(props: Props) {
	const link = getLink(props);

	if (link && !props.isEditableMode) {
		const target = props.uiConfig.componentProps[UNIFORM_PROPS.btnTarget];

		return {
			Component: 'a',
			href: prependUrlProtocol(link),
			target: target ? '_blank' : '_self',
			rel: target ? 'noopener noreferrer' : undefined,
		};
	}

	return {
		Component: 'div',
	};
}

function getLink(props: Props) {
	return props.uiConfig.componentProps[UNIFORM_PROPS.btnLink];
}

export default withCardTransitionContext(Img);
